<template>
  <public-layout>
    <h1 class="title">Error 500!</h1>
    Oh no. There has been an error. If you want to help us, you can message us,
    or try going back to work!
    <div class="buttons">
      <bg-button class="action" text="Message us!" @click="openHelpCrunch" />
      <bg-button
        class="action"
        variant="secondary"
        text="Back to work!"
        @click="() => this.$router.push(`/tests/`)"
      />
    </div>
  </public-layout>
</template>

<style scoped>
.title {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 10px;
}
.buttons {
  margin-top: 20px;
  width: 600px;
  display: flex;
  justify-content: space-between;
}
</style>

<script>
import PublicLayout from "@/layouts/public";
import BgTypography from "@/directives/bg-typography";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import BgButton from "@/components/bg-button";
import BgLogo from "@/components/bg-logo";
import BgCheckbox from "@/components/bg-checkbox";
import API from "@/api";

export default {
  name: "signup",
  components: {
    BgButton,
    BgInput,
    BgField,
    BgCheckbox,
    PublicLayout,
    BgLogo,
  },
  directives: {
    BgTypography,
  },
  data: () => ({
    validToken: false,
    isSigninLoading: false,
    errors: {},
  }),
  methods: {
    openHelpCrunch() {
      HelpCrunch("openChat");
      HelpCrunch("typeUserMessage", `Ahhh, there's been an error!`);
    },
  },
};
</script>
